(ns minorodata.transformations.model
  (:require [mold.core :as m :refer-macros [defmodel]]
            [minorodata.transform.model :refer [transform transform-tag]]
            [minorodata.group.model :refer [group]]))


(defmodel task-status
  {:transform {::m/type     ::m/ref
               ::m/ref-type transform
               ::m/doc      "Task related transforms refs"}
   :status    [::m/keyword "Actual task status"]})


(defmodel job
  {:id            [::m/identity ::m/req ::m/string "Job id"]
   :name          [::m/string "job (initial transform) name"]
   :execution-id  [::m/string "Job execution id"]
   :status        [::m/keyword "Job status"]
   :errors        [::m/map ::m/nilable "Job errors"]
   :start-time    [::m/string ::m/nilable "Job start time"]
   :end-time      [::m/string ::m/nilable "Job end time"]
   :task-statuses {::m/type         ::m/ref
                   ::m/cardinality  ::m/many
                   ::m/is-component ::m/component
                   ::m/ref-type     task-status
                   ::m/doc          "Individual transform status"}})


(defmodel transformations-view
  {:has-cycles      [::m/bool "Is any transform has cyclic deps flag"]
   :edges           [::m/set "Edges in the cyclic dependency"]
   :transforms-tags {::m/type        ::m/ref
                     ::m/cardinality ::m/many
                     ::m/ref-type    transform-tag
                     ::m/doc         "Transforms tags"}
   :sql-completions [::m/vector "Autocomplete options for SQL editor"]
   :jobs            {::m/type        ::m/ref
                     ::m/cardinality ::m/many
                     ::m/ref-type    job
                     ::m/doc         "Currently running jobs"}}
  {:singleton true})


(defmodel transformations-search
  {:transforms    {::m/type        ::m/ref
                   ::m/cardinality ::m/many
                   ::m/ref-type    transform
                   ::m/doc         "Transforms related to the current search"}
   :groups        {::m/type        ::m/ref
                   ::m/cardinality ::m/many
                   ::m/ref-type    group
                   ::m/doc         "Groups related to the current search"}
   :term          [::m/string "Search term filter"]
   :search-filter [::m/string "Search specificity filtering option"]
   :type          {::m/type ::m/enum
                   ::m/vals #{:both :transform :group}
                   ::m/doc  "Search type filter"}
   :updated-by    [::m/vector "User ids filter"]
   :updated-at    [::m/map "Date range filter map of {:to ... :from ...}"]
   :status        [::m/vector "Status filter"]
   :scheduled     [::m/bool "Search for scheduled only"]
   :tags          [::m/vector "Tags ids filter"]}
  {:singleton true})
